export default __webpack_public_path__ + "static/media/IconDesc_CupGold.256.eee98e24.png";